import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ScrollArea, UserAvatar, Button } from '@app/shared/ui/atoms/Common';
import { LogOutButton } from '@app/shared/ui/atoms/EditProfile';
import { TopBar } from '@app/shared/ui/molecules/EditProfile';
import { ProfileForm } from '@app/shared/ui/organisms/EditProfile';
import { useGetCurrentUserProfileQuery } from '@app/store/slices/users/usersApi';
import { useAppDispatch } from '@app/store/hooks';
import { tutorialActions } from '@app/store/slices/tutorial/tutorialSlice';
import { openModal } from '@app/store/slices/modal/modalSlice';

export default function EditProfilePage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { data: userProfile, isLoading: isUserProfileLoading } = useGetCurrentUserProfileQuery();

  const onClickRepeatTutorial = () => {
    dispatch(tutorialActions.start(true));
    void navigate('/');
  };

  return (
    <ScrollArea>
      <TopBar />
      <UserAvatar
        avatar={userProfile?.avatar}
        isAvatarLoading={isUserProfileLoading}
        gender={userProfile?.gender}
        className="mx-auto mt-4 size-[140px]"
      />
      <ProfileForm />
      <div className="px-3 pt-3">
        <Button onClick={onClickRepeatTutorial}>{t(`tutorial.repeat`)}</Button>
      </div>
      <div className="px-3 pt-3">
        <Button onClick={() => dispatch(openModal('userAgreement'))}>
          {t(`userAgreement.read`)}
        </Button>
      </div>
      <div className="px-3">
        <LogOutButton />
      </div>
    </ScrollArea>
  );
}
